
<script setup>
import { ref } from 'vue'
import { supabase } from '@/supabase';
import router from '@/router';
import Button from 'primevue/button';
import ProgressBar from 'primevue/progressbar';
import ProgressSpinner from 'primevue/progressspinner';
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const loading = computed(() => store.state.loading);
const paginaFazerLogin = computed(() => store.state.paginaFazerLogin);


 async function loginGoogle() {
   store.dispatch('updateLoading', true)
   const { data, error } = await supabase.auth.signInWithOAuth({
     provider: 'google',
     options: {
       scopes: 'email',
     },
   })
   if (error) {
     alert('Ocorreu um erro ao fazer login')
   }
 }

async function loginMicrosoft() {
  store.dispatch('updateLoading', true)
  const { data, error } = await supabase.auth.signInWithOAuth({
    provider: 'azure',
    options: {
      scopes: 'openid email profile',
    },
  })

  if (error) {
    alert('Ocorreu um erro ao fazer login')
  }
}
</script>



<template>
  <ProgressBar v-if="loading" mode="indeterminate" style="height: 3px" class="z-5 progress-bar"></ProgressBar>
  <div class="flex justify-content-center align-content-center flex-wrap	h-full	p-3">

    <div class="surface-card p-4 shadow-2 border-round w-full md:w-5 mb-5" >
      <div v-if="paginaFazerLogin">
        <div class="text-center mb-7">
          <img :src="require('@/assets/logo.svg')" alt="Image" height="50" class="mb-5" />
          <div class="color-text text-3xl font-medium mb-3">Bem-vindo!</div>
        </div>

        <div>
          <div class="flex flex-column gap-3">
            <Button class="w-full" @click="loginMicrosoft" icon="pi pi-microsoft" label="Fazer login com o Teams" />
            <Button class="w-full" @click="loginGoogle" icon="pi pi-google" label="Fazer login com o Google" outlined />
          </div>
        </div>
      </div>
      <div v-else class="color-text  h-full w-full flex flex-column align-items-center justify-content-center p-5">
        <ProgressSpinner style="width: 50px; height: 50px" strokeWidth="3" fill="var(--surface-ground)"
          animationDuration=".5s" aria-label="Custom ProgressSpinner" class="mb-3" />
        Você está sendo redirecionado para o app Minha Escola, um momento...
      </div>

    </div>
  </div>
</template>